import { render, staticRenderFns } from "./convivencia.vue?vue&type=template&id=0fc8a269&"
import script from "./convivencia.vue?vue&type=script&lang=js&"
export * from "./convivencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports